import i18n from 'i18next'
import { getStack } from '@nuskin/contentstack-lib'
import { getLocaleCodeFromUrl } from 'src/utils'
import { APPConfig, IS_BROWSER } from 'config/appConfig'
import { convertToBoolean } from 'src/utils'
import { translationStore } from 'src/models/TranslationStore/TranslationStore'
import isEmpty from 'lodash/isEmpty'

export let contentFromCS = {}

/**
 * Translates the given locale key and locale value using i18next.
 *
 * @param {string} localeKey - The locale key to translate
 * @param {string} [localeValue] - The locale value to interpolate
 * @param {Object} options - Additional options
 * @param {('csr-resource'|'ssr-resource')} [options.nameSpace='csr-resource'] - The namespace to prefix the locale key
 * @returns {string} The translated string
 */
function i18nTranslate(localeKey, localeValue, options) {
  let enableTranslationFromContentStack = false
  if (IS_BROWSER) {
    enableTranslationFromContentStack =
      window.enableTranslationFromContentStack || false
    // getting from app config causes slowness in forms
    // hence setting in translation store and using it
  } else {
    enableTranslationFromContentStack = convertToBoolean(
      APPConfig?.getAppConfig()?.enableTranslationFromContentStack
    )
  }
  const { nameSpace = 'csr-resource', isNextGenTranslations = false } =
    options || {}

  if (enableTranslationFromContentStack) {
    return translationStore.translate(
      localeKey,
      localeValue,
      nameSpace,
      isNextGenTranslations
    )
  } else {
    return i18n.t(`${nameSpace}:${localeKey}`, localeValue) || localeValue
  }
}
async function getContentFromCS(
  entry = 'jitsu_strings',
  environmentOverride = ''
) {
  if (contentFromCS[entry]) {
    return contentFromCS[entry]
  }
  let env = environmentOverride || APPConfig?.getAppConfig()?.CS_ENV
  // env should be sent without 'public-' prefix
  env = env?.replace('public-', '')
  try {
    const Stack = getStack(env)
    const curLocale = getLocaleCodeFromUrl({
      isReverseType: true,
      defaultLocale: 'en_US',
    })

    const [language, country] = curLocale?.includes('_')
      ? curLocale?.split('_')
      : curLocale?.split('-')
    const [data = {}] = await Stack.getSingletonEntries({
      contentTypeUIDs: [entry],
      country: country,
      language: language,
      camelcase: true,
      mergeWithFallback: true,
    })
    if (!isEmpty(data)) {
      contentFromCS[entry] = data
    }
    return data
  } catch (e) {
    console.log('Error in getContentFromCS', e)
    return {}
  }
}

if (IS_BROWSER) {
  globalThis.i18nTranslate ||= i18nTranslate
}

export { i18nTranslate, getContentFromCS }
